<template>
  <div class="card m-t-10">
    <div class="card-header">
      <span v-if="indicator.obligation === 'Major' || indicator.obligation === 'MAJOR_MUST'" class="ribbon-red">
        <span>Major</span>
      </span>
      <span v-else-if="indicator.obligation === 'Minor' || indicator.obligation === 'MINOR_MUST'" class="ribbon-yellow">
        <span>Minor</span>
      </span>
      <span v-else-if="indicator.obligation" class="ribbon-green">
        <span :class="{'risk-factor': indicator['obligation'] === 'Risk Factor'}">{{ indicator.obligation }}</span>
      </span>
      <div class="row">
        <div class="col-2">
          <h4 class="card-title">
            {{ name }}
          </h4>
        </div>
      </div>
    </div>

    <div class="card-body">
      <p class="card-text">
        {{ indicator["description"] }}
      </p>
    </div>
    <div v-if="!showForm" class="card-footer border-top">
      <div :id="'accordionid'+id">
        <div v-for="(observation, index) in observations" :key="observation.observation_id" class="card mb-0  card-border">
          <div :id="'heading'+observation.observation_id" class="card-header bg-grey card-header-border p-1" @click="cancel()">
            <h5 :data-target="'#collapse'+observation.observation_id" class="mb-0" data-toggle="collapse" style="cursor: pointer">
              <button :data-target="'#collapse'+observation.observation_id" aria-controls="collapseOne" aria-expanded="true" class="btn btn-link collapsed" data-toggle="collapse">
                View Observation #{{ index+1 }}
              </button>
              <a v-if="observation.proposal_id" class="btn btn-link collapsed float-right" href="javascript:void(0)" @click="getProposal(observation.proposal_id)">Click here to view details</a>
            </h5>
          </div>

          <div :id="'collapse'+observation.observation_id" :aria-labelledby="'heading'+observation.observation_id" :class="{'show': index+1 === observations.length}" :data-parent="'#accordionid'+id" class="collapse">
            <div class="card-body">
              <form class="form-horizontal">
                <div class="form-body">
                  <div class="card-body">
                    <h4 class="card-title">
                      Observation
                    </h4>
                  </div>
                  <hr class="m-t-0 m-b-10">
                  <div class="card-body">
                    <div class="row">
                      <label class="control-label col-md-2">Compliance</label>
                      <div class="col-md-6 text-left">
                        <span v-if="observation.compliance === 'Compliant'" class="label label-dark-green">Compliant</span>
                        <span v-if="observation.compliance === 'NonCompliant'" class="label label-danger">Non-Compliant</span>
                        <span v-if="observation.compliance === 'NotApplicable'" class="label label-secondary">Not Applicable</span>
                      </div>
                    </div>
                    <div v-if="observation.procedural_note" class="row mt-2">
                      <label class="col-md-2 control-label col-form-label">Notes</label>
                      <div class="col-sm-6 text-left">
                        <span class="form-control" v-html="observation.procedural_note" />
                      </div>
                    </div>
                    <div v-if="observation.extrinsic" class="row mt-2">
                      <label class="col-md-2 control-label col-form-label">Transaction
                        Details</label>
                      <div class="col-sm-6 mt-2 text-left">
                        <a target="_blank" :href="$BORLAUG + '/tx/' + observation.extrinsic">View
                          Confirmation
                          on Blockchain</a>
                      </div>
                    </div>
                    <!--/row-->
                    <div v-if="linkedEvidence" class="d-md-flex custom-margin">
                      <div>
                        <h4 class="card-title">
                          Linked Evidence
                        </h4>
                      </div>
                      <div class="ml-auto d-flex no-block align-items-center">
                        <div class="dl">
                          <div class="button-group">
                            <button v-if="status === 'InProgress' && observation.status !== 'Draft' && isAuditor()" class="btn btn-outline-info waves-effect waves-light" @click="getAllLinkedAttachments(observation.observation_id)">
                              <i class="fas fa-link" /> Link Evidence
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="linkEvidence" class="d-md-flex custom-margin">
                      <div>
                        <h4 class="card-title">
                          Link Evidence
                        </h4>
                      </div>
                    </div>
                  </div>
                  <hr class="m-t-0 m-b-10">
                  <div v-if="linkedEvidence && observation.evidences && observation.evidences.length>0" class="card-body">
                    <div class="table-responsive">
                      <table class="table v-middle">
                        <thead>
                          <tr>
                            <th class="border-top-0" scope="col">
                              #
                            </th>
                            <th class="text-left border-top-0" scope="col">
                              File Name
                            </th>
                            <th class="text-left border-top-0" scope="col">
                              Description
                            </th>
                            <!--                                                                                        <th class="text-left border-top-0" scope="col">Created At</th>-->
                            <!--                                                                                        <th class="text-left border-top-0" scope="col">Transaction</th>-->
                            <th v-if="status === 'InProgress' && isAuditor()" class="text-left border-top-0" scope="col">
                              Action
                            </th>
                          </tr>
                          <tr v-for="(attachment, index) in observation.evidences" :key="index">
                            <td>{{ index + 1 }}</td>
                            <td>
                              <a href="javascript:void(0)" @click="downloadFile(attachment)">{{
                                attachment.name }}</a>
                            </td>
                            <td :title="attachment.description" class="masked">
                              {{
                                attachment.description }}
                            </td>
                            <!--                                                                                        <td>{{ attachment.created | date }}</td>-->
                            <!--                                                                                        <td :title="attachment.extrinsic"-->
                            <!--                                                                                            class="masked">-->
                            <!--                                                                                            <a target="_blank"-->
                            <!--                                                                                               v-bind:href="$BORLAUG + '/tx/' + attachment.extrinsic"-->
                            <!--                                                                                               v-if="attachment.extrinsic">View-->
                            <!--                                                                                                Confirmation-->
                            <!--                                                                                                on-->
                            <!--                                                                                                Blockchain</a>-->
                            <!--                                                                                        </td>-->
                            <td v-if="status === 'InProgress' && isAuditor()">
                              <div class="button-group">
                                <button class="btn btn-sm waves-effect waves-light btn-outline-danger" type="button" @click="unlinkAttachment(observation.observation_id, attachment.evidence_id, attachment.id)">
                                  <i class="mdi mdi-link-variant-off" />
                                  Unlink
                                </button>
                              </div>
                            </td>
                          </tr>
                        </thead>
                      </table>
                    </div>
                  </div>
                  <div v-else-if="linkedEvidence" class="card-body">
                    <h4 class="card-title text-muted text-center">
                      No records found
                    </h4>
                  </div>

                  <div v-if="linkEvidence" class="card-body linking-form">
                    <div class="col-lg-12 col-md-12">
                      <div class="form-group row">
                        <label class="control-label col-md-2">Select
                          File<p class="font-10">(Select a uploaded file to link to this observation)</p></label>
                        <div class="col-md-6 text-left">
                          <multiselect id="evidences" v-model="fileObj" :clear-on-select="true" :close-on-select="true" :hide-selected="false" :internal-search="false" :multiple="false" :options="evidencesToLink" :preselect-first="false" :preserve-search="true" :searchable="false" class="form-control" label="evidence" name="evidence" placeholder="Select a uploaded file" track-by="id">
                            <template slot="singleLabel" slot-scope="props">
                              {{ props.option.name }}
                            </template>
                            <template slot="option" slot-scope="props">
                              <div class="option__desc">
                                <h5>{{ props.option.name }}</h5>
                              </div>
                            </template>
                          </multiselect>
                        </div>
                        <div class="col-sm-3">
                          <a class="btn btn-group-lg waves-effect waves-light btn-outline-success" href="javascript:void(0)" type="submit" @click="linkAttachment(observation.observation_id)">
                            Save
                          </a>
                          &nbsp;
                          Or
                          <a class="btn btn-md btn-link font-16" href="javascript:void(0)" type="button" @click="cancel()">Cancel
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <img alt="" class="loader-gif center" src="../../../../assets/images/loader.gif">
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div class="row d-flex mt-3">
        <div class="col-12 text-right">
          <button v-if="(status === 'Accepted' || status === 'InProgress') && observation.status !== 'Draft' && isAuditor()" class="btn btn-dark waves-effect waves-light m-r-5" type="button" @click="showObservation(indicator, 'New')">
            <i class="mdi mdi-plus-box" />&nbsp;Observation
          </button>
          <button v-if="(status === 'Accepted' || status === 'InProgress') && observation.status === 'Draft' && isAuditor()" class="btn btn-dark waves-effect waves-light m-r-5" type="button" @click="showObservation(indicator, 'Old')">
            <i class="mdi mdi-pencil" />&nbsp;Edit
          </button>
        </div>
      </div>
    </div>
    <ul v-if="showForm" id="myTab" class="nav nav-tabs" role="tablist">
      <li class="nav-item">
        <a id="home-tab" :aria-controls="'home5'+id" aria-expanded="true" class="nav-link active" data-toggle="tab" role="tab" :href="'#home5'+id">
          <span class="hidden-sm-up"><i class="ti-eye" /></span>
          <span class="hidden-xs-down  m-l-5">Observation</span>
        </a>
      </li>
      <li class="nav-item">
        <a :aria-controls="'dropdown1'+id" aria-expanded="false" class="nav-link" data-toggle="tab" role="tab" :href="'#dropdown1'+id">
          <span class="hidden-sm-up"><i class="ti-files" /></span>
          <span class="hidden-xs-down  m-l-5">Evidence</span>
        </a>
      </li>
    </ul>

    <div v-if="showForm" id="myTabContent" class="tab-content tabcontent-border p-20">
      <div :id="'home5'+id" aria-labelledby="home-tab" class="tab-pane fade active show" role="tabpanel">
        <div class="card-body col-lg-12 col-md-12">
          <div class="form-group row">
            <label class="control-label col-md-2">Compliance&nbsp;<span class="text-danger">*</span></label>
            <div class="col-md-8 text-left">
              <div class="form-check form-check-inline">
                <div class="custom-control custom-radio">
                  <input :id="'yes'+id" v-model="observation.compliance" v-validate="'required|included:Compliant,NonCompliant,NotApplicable'" :class="{'is-invalid': submitted && errors.has('compliance')}" class="custom-control-input" data-vv-as="Compliance" name="compliance" type="radio" value="Compliant">
                  <label :for="'yes'+id" class="custom-control-label">Yes</label>
                </div>
              </div>
              <div class="form-check form-check-inline">
                <div class="custom-control custom-radio">
                  <input :id="'no'+id" v-model="observation.compliance" class="custom-control-input" name="compliance" type="radio" value="NonCompliant">
                  <label :for="'no'+id" class="custom-control-label">No</label>
                </div>
              </div>
              <div class="form-check form-check-inline">
                <div class="custom-control custom-radio">
                  <input :id="'na'+id" v-model="observation.compliance" class="custom-control-input" name="compliance" type="radio" value="NotApplicable">
                  <label :for="'na'+id" class="custom-control-label">Not Applicable</label>
                </div>
              </div>
              <div v-if="submitted && errors.has('compliance')" class="text-danger">
                {{
                  errors.first('compliance') }}
              </div>
            </div>
          </div>
          <div class="form-group row">
            <label class="control-label text-left col-md-4">Comments</label>
            <div class="col-md-12">
              <document-editor :id="name" :editor-disabled="false" :editor-size="'SMALL'" :value="observation.procedural_note" @input="getDataFromEditor" />
            </div>
          </div>
          <!--                    <div class="form-group row">-->
          <!--                        <label class="control-label col-md-2">Select-->
          <!--                            File<p class="font-10">(Select a uploaded file to link to this observation)</p></label>-->

          <!--                        <div class="col-md-6 text-left">-->
          <!--                            <multiselect :clear-on-select="true"-->
          <!--                                         :close-on-select="true"-->
          <!--                                         :hide-selected="false"-->
          <!--                                         :internal-search="false"-->
          <!--                                         :multiple="false"-->
          <!--                                         :options="attachmentList"-->
          <!--                                         :preselect-first="false"-->
          <!--                                         :preserve-search="true"-->
          <!--                                         :searchable="false"-->
          <!--                                         class="form-control"-->
          <!--                                         id="evidences_form"-->
          <!--                                         label="evidence"-->
          <!--                                         name="evidence"-->
          <!--                                         placeholder="Choose file"-->
          <!--                                         track-by="id"-->
          <!--                                         v-model="fileObj">-->
          <!--                                <template slot="singleLabel" slot-scope="props">-->
          <!--                                    {{props.option.name}}-->
          <!--                                </template>-->
          <!--                                <template slot="option" slot-scope="props">-->
          <!--                                    <div class="option__desc">-->
          <!--                                        <h5>{{ props.option.name }}</h5>-->
          <!--                                    </div>-->
          <!--                                </template>-->
          <!--                            </multiselect>-->
          <!--                        </div>-->
          <!--                    </div>-->
        </div>
        <hr>
        <div class="button-group card-footer row m-r-auto">
          <div class="col-md-6">
            <button :disabled="!saveShow" class="text-white btn waves-effect waves-light btn-success  w-75" type="button" @click="save('Committed')">
              <span v-if="saveShow"><i class="fa fa-arrow-circle-right" />&nbsp;&nbsp;Save</span>
              <span v-if="!saveShow"><i class="fa fa-spinner fa-spin" /> &nbsp;Loading</span>
            </button>
            <p class="m-l-10">
              Save to Blockchain. You can't edit after this
            </p>
          </div>
          <div class="col-md-6">
            <button :disabled="!saveDraftShow" class="btn waves-effect waves-light btn-primary w-50" type="submit" @click="save('Draft')">
              <span v-if="saveDraftShow"><i class="fa fa-save" />&nbsp;&nbsp;Save Draft</span>
              <span v-if="!saveDraftShow"><i class="fa fa-spinner fa-spin" /> &nbsp;Loading</span>
            </button>
            Or
            <a class="font-16" href="javascript:void(0)" @click="hideObservation()">&nbsp;Cancel</a>
            <p class="m-l-10">
              Save as Draft. You can edit again later
            </p>
          </div>
        </div>
      </div>
      <div :id="'dropdown1'+id" aria-labelledby="dropdown1-tab" class="tab-pane fade " role="tabpanel">
        <div class="card-body upload-form">
          <div class="col-lg-12 col-md-12">
            <form class="form-horizontal" @submit.prevent="handleSubmit">
              <div class="form-group row">
                <label class="control-label col-md-2">Upload New File</label>
                <div class="col-md-6 text-left">
                  <div class="input-group mb-1">
                    <div class="custom-file">
                      <input id="file" ref="file" :class="{'is-invalid': submitted && error.length>0}" accept="*" class="custom-file-input" data-vv-as="Attachment" name="file" type="file" @change="onFileChange()">
                      <label class="custom-file-label text-ellipsis">{{ filename }}</label>
                    </div>
                  </div>
                  <div v-if="submitted && error" class="text-danger">
                    {{ error[0] }}
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label class="control-label col-md-2">Description</label>
                <div class="col-md-6 text-left">
                  <textarea id="desc" v-model="evidence_desc" class="form-control" name="desc" placeholder="Attachment Description" rows="4" type="text" />
                </div>
              </div>
              <div class="form-group row float-right">
                <div class="button-group">
                  <button :disabled="!saveShow" class="btn waves-effect waves-light btn-success" type="submit">
                    <span v-if="saveShow">Save</span>
                    <span v-if="!saveShow"><i class="fa fa-spinner fa-spin" /> &nbsp;Loading</span>
                  </button>
                  <button class="btn waves-effect waves-light btn-secondary" type="button" @click="reset()">
                    Reset
                  </button>
                  Or
                  <button class="btn btn-md btn-link font-16" type="button" @click="hideObservation()">
                    Cancel
                  </button>
                </div>
              </div>
            </form>
          </div>
          <div class="col-lg-12 col-md-12">
            <h6 class="card-title m-t-40">
              <i class="m-r-5 font-18 mdi mdi-file-multiple" /> Uploaded Files
            </h6>
            <table v-if="attachmentList.length>0" class="table">
              <thead>
                <tr>
                  <th scope="col">
                    #
                  </th>
                  <th class="text-left" scope="col">
                    File Name
                  </th>
                  <th class="text-left" scope="col">
                    Description
                  </th>
                  <th class="text-left" scope="col">
                    Created At
                  </th>
                  <th class="text-left" scope="col">
                    Transaction
                  </th>
                  <th class="text-left" scope="col">
                    Action
                  </th>
                </tr>
                <tr v-for="(attachment, index) in attachmentList" :key="index">
                  <td class="masked">
                    {{ index + 1 }}
                  </td>
                  <td class="masked">
                    {{ attachment.name }}
                  </td>
                  <td :title="attachment.description" class="masked">
                    {{ attachment.description }}
                  </td>
                  <td class="masked">
                    {{ attachment.created | date }}
                  </td>
                  <td :title="attachment.extrinsic" class="masked">
                    <a v-if="attachment.extrinsic" target="_blank" :href="$BORLAUG + '/tx/' + attachment.extrinsic">View
                      Confirmation
                      on
                      Blockchain</a>
                  </td>
                  <td class="masked">
                    <button class="btn btn-sm waves-effect waves-light btn-outline-danger" data-target="#deleteModal" data-toggle="modal" type="button" @click="setEvidenceId(attachment.evidence_id)">
                      <i class="mdi mdi-delete" /> Delete
                    </button>
                  </td>
                </tr>
              </thead>
            </table>
            <div v-else class="card-body">
              <h4 class="card-title text-muted text-center">
                No records found
              </h4>
            </div>
          </div>
        </div>

        <div class="form-group row">
          <img alt="" class="loader-gif center" src="../../../../assets/images/loader.gif">
        </div>
      </div>
    </div>

    <div aria-hidden="true" aria-labelledby="myModalLabel" class="modal fade" id="deleteModal" role="dialog"
         tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" id="exampleModalLabel1">Are you sure you want to delete this audit?</h4>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button"><span
              aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <form>
              <div class="form-group">
                <label class="control-label">Comments:</label>
                <textarea class="form-control" id="message-text1" v-model="comments"></textarea>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button :disabled="isDeleted" @click="deleteFile()"
                    class="btn waves-effect waves-light btn-success"
                    type="button">
              <span v-if="!isDeleted">Yes</span>
              <span v-if="isDeleted"><i class="fa fa-spinner fa-spin"/> &nbsp;Loading</span>
            </button>
            <button class="btn waves-effect waves-light btn-danger" data-dismiss="modal" type="button">
              No
            </button>
          </div>
        </div>
      </div>
    </div>
    <proposal-stat :proposal="proposal" />
  </div>
</template>

<script>
import uuid from 'uuid/v4';
import { mapGetters } from 'vuex';
import EventBus from '@/event-bus';
import DocumentEditor from '@/components/protected/common/DocumentEditor.vue';
import Multiselect from 'vue-multiselect';
import ProposalStat from '@/components/protected/common/ProposalStat.vue';
import {apiMixin} from '@/utils/api-mixin';

export default {
  name: 'Indicator',
  mixins: [apiMixin('audit')],
  components: { ProposalStat, DocumentEditor, Multiselect },
  props: ['auditId', 'indicator', 'id', 'name', 'events', 'status', 'auditor'],
  data() {
    return {
      error: [],
      observations: [],
      tv_obs: [],
      observation: {
        control_point_id: null,
        observation_id: null,
        compliance: null,
        procedural_note: '',
        status: null
      },
      submitted: false,
      showForm: false,
      file: null,
      filename: 'Choose File',
      filetype: '',
      documentid: '',
      attachments: [],
      attachmentList: [],
      auditStatus: '',
      isReadOnly: true,
      saveShow: true,
      saveDraftShow: true,
      evidences: [],
      attachmentsForIndicator: [],
      evidencesToLink: [],
      showEvidenceList: true,
      isDeleted: false,
      evidenceIdToDelete: null,
      fileObj: null,
      auditors: [],
      evidence_desc: '',
      linkEvidence: false,
      linkedEvidence: true,
      comments: null,
      proposal_id: null,
      proposal: null
    };
  },
  computed: {
    ...mapGetters(['currentUser', 'activeGroup', 'publicKey'])
  },
  watch: {
    id: function () {
      this.getObservations();
    },
    auditId: function (newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.init();
      }
    }
  },
  mounted() {
    this.init();
    $('.loader-gif').hide();
    EventBus.$on('auditStatus', status => {
      this.auditStatus = status;
    });
    EventBus.$on('resetProposalId', () => {
      this.proposal_id = null;
    });
  },
  methods: {
    async init() {
      await this.getObservations();
      await this.getDraftObservation();
      await this.getAllAttachments();
    },

    async getDraftObservation() {
      try {
        const { data } = await this.$api.get(`audits/${this.auditId}/control_points/${this.id}/observations/draft`);
        if (data) {
          data.observation_id = uuid();
          data.status = 'Draft';
          this.observation = data;
          this.observations.push(data);
        }
      } catch (e) {
        console.error(e);
      }
    },
    async getObservations() {
      try {
        const { data } = await this.$api.get(`audits/${this.auditId}/control_points/${this.id}/observations`);
        this.observations = data.length > 0 ? data.reverse() : [];
        this.observation.status = data.length > 0 ? 'Committed' : '';
      } catch (e) {
        console.error(e);
      }
    },
    async getAuditors() {
      this.auditors = [];
      try {
        const { data } = await this.$api.get(`/audits/${this.auditId}/auditors`);
        this.auditors = data.auditors;
      } catch (e) {
        console.log(e);
      }
    },
    async showObservation(_indicator, new_old) {
      this.attachments = [];
      await this.init();
      if (new_old === 'New') {
        this.observation = {
          control_point_id: null,
          observation_id: null,
          compliance: null,
          procedural_note: '',
          status: null
        };
      } else {
        this.observation.observation_id = this.observations.length > 0 ? this.observations[this.observations.length - 1].observation_id : null;
        this.observation.compliance = this.observations.length > 0 ? this.observations[this.observations.length - 1].compliance : null;
        this.observation.procedural_note = this.observations.length > 0 ? this.observations[this.observations.length - 1].procedural_note : null;
      }
      this.showForm = true;
    },
    hideObservation() {
      this.showForm = false;
      this.saveShow = true;
      this.saveDraftShow = true;
    },
    handleSubmit() {
      this.submitted = true;
      this.error = [];
      if (!this.file) {
        this.error.push('Attachment field required.');
        return;
      }
      this.saveEvidence();
    },
    async save(_status) {
      if (this.observation.compliance) {

        // eslint-disable-next-line no-unused-vars
        let isProposal = false;
        if (this.activeGroup && this.activeGroup.threshold > 1 && _status === 'Committed') {
          isProposal = true;
        }
        await this.callApi('loader', isProposal, 'Observation made', async () => {
          if (_status === 'Draft') {
            this.saveDraftShow = false;
          } else if (_status === 'Committed') {
            this.saveShow = false;
          }
          this.observation.status = _status;
          this.observation.control_point_id = this.id;
          await this.$api.post(`/audits/${this.auditId}/control_points/${this.id}/observations`, this.observation);
          await this.getObservations();
          await this.getDraftObservation();
        });
        EventBus.$emit('updateControlPoint');
        this.hideObservation();
        this.fileObj = null;
        this.saveShow = true;
        this.saveDraftShow = true;
        if(isProposal){
          this.$router.push({name: 'proposals'});
        }
      } else {
        this.$toastr.e('Check compliance first', 'Failed');
      }
    },
    getDataFromEditor(event) {
      this.observation.procedural_note = event;
    },
    async onFileChange() {
      this.file = this.$refs.file.files[0];
      if (this.file) {
        this.error.pop();
      }
      this.filename = this.file.name;
      this.filetype = this.file.type;
      this.documentid = uuid();
    },
    async saveEvidence() {
      // eslint-disable-next-line no-unused-vars
      let isProposal = false;
      if (this.activeGroup && this.activeGroup.threshold > 1) {
        isProposal = true;
      }
      await this.callApi('loader', isProposal, 'Attachment saved', async () => {
        const formData = new FormData();
        formData.append('file', this.file);
        const { data } = await this.$apiFile.post(`/audits/${this.auditId}/evidences`, formData);
        if (data.event) {
          await this.$api.patch(`/audits/${this.auditId}/evidences/${data.event.evidence_id}`, {
            description: this.evidence_desc
          });
        }
        this.$refs.file.value = '';
        this.filename = 'Choose File';
      });
      if(isProposal){
        this.$router.push({name: 'proposals'});
      }
      this.reset();
      await this.init();
    },
    async unlinkAttachment(observation_id, evidence_id) {
      // eslint-disable-next-line no-unused-vars
      let isProposal = false;
      if (this.activeGroup && this.activeGroup.threshold > 1) {
        isProposal = true;
      }
      await this.callApi('loader', isProposal, 'Evidence unlinked', async () => {
        await this.$api.delete(`audits/${this.auditId}/evidences/${evidence_id}/link`, {
          data: {
            control_point_id: this.id,
            observation_id: observation_id,
            comments: 'Attachment unlinked'
          }
        });
      });
      if(isProposal){
        this.$router.push({name: 'proposals'});
      }
      this.linkedEvidence = true;
      await this.init();
    },
    async getAllAttachments() {
      this.attachmentList = [];
      const { data } = await this.$api.get(`audits/${this.auditId}/evidences`);
      this.attachmentList = data;
    },
    async getAllLinkedAttachments(observation) {
      this.linkedEvidence = false;
      this.linkEvidence = true;
      this.attachments = [];
      this.evidencesToLink = this.attachmentList;
      try {
        $('.linking-form').hide();
        $('.loader-gif').show();
        const { data } = await this.$api.get(`audits/${this.auditId}/control_points/${this.id}/observations/${observation}/evidences`);
        this.attachments = data;
        this.evidencesToLink = this.attachmentList.filter(a => !this.attachments.includes(a.evidence_id));
      } catch (e) {
        console.error(e);
      } finally {
        $('.loader-gif').hide();
        $('.linking-form').show();
      }
    },
    async linkAttachment(observation_id) {
      // eslint-disable-next-line no-unused-vars
      let isProposal = false;
      if (this.activeGroup && this.activeGroup.threshold > 1) {
        isProposal = true;
      }
      await this.callApi('loader', isProposal, 'Evidence linked', async () => {
        if (observation_id) {
          await this.$api.post(`audits/${this.auditId}/evidences/${this.fileObj.evidence_id}/link`, {
            control_point_id: this.id,
            observation_id: observation_id,
            comments: 'Attachment linked'
          });
        }
      });
      if(isProposal){
        this.$router.push({name: 'proposals'});
      }
      this.fileObj = null;
      this.linkedEvidence = true;
      this.linkEvidence = false;
      await this.init();
    },
    setEvidenceId(_evidenceid) {
      this.evidenceIdToDelete = _evidenceid;
    },
    async deleteFile() {
      // eslint-disable-next-line no-unused-vars
      let isProposal = false;
      this.isDeleted = true;
      $('#deleteModal').modal('toggle');
      if (this.activeGroup && this.activeGroup.threshold > 1) {
        isProposal = true;
      }
      await this.callApi('loader', isProposal, 'Audit removed', async () => {
        await this.$api.delete(`/audits/${this.auditId}/evidences/${this.evidenceIdToDelete}`, {
          data: {
            comments: this.comments
          }
        });
      });
      if (isProposal) {
        this.$router.push({name: 'proposals'});
      }
      this.evidenceIdToDelete = null;
      await this.init();
      this.isDeleted = false;
    },
    isAuditor() {
      return (this.activeGroup && (this.auditor === this.activeGroup.anonymous_account));
    },
    async userprofile(email, orgid) {
      try {
        const { data } = await this.$accounts.get(`accounts/orgs/${this.currentUser.org_id}/members?page=0&per_page=100`);
        const user = data.users.find(u => u.email == email);
        const routeData = this.$router.resolve({
          name: 'userprofile',
          params: { memberid: user.user, orgid: orgid }
        });
        window.open(routeData.href, '_blank');
      } catch (e) {
        console.error(e);
      }
    },
    async downloadFile(attachment) {
      const { data } = await this.$api.get(`/audits/${this.auditId}/evidences/${attachment.evidence_id}/file`);
      const link = document.createElement('a');
      link.href = 'data:application/octet-stream;base64,' + data;
      link.download = attachment.name;
      link.click();
    },
    reset() {
      this.file = null;
      this.evidence_desc = '';
    },
    cancel() {
      this.fileObj = null;
      this.linkedEvidence = true;
      this.linkEvidence = false;
    },
    async getProposal(proposal_id) {
      this.proposal = null;
      try {
        const { data } = await this.$api.get(`/groups/proposals/${proposal_id}`);
        const yes_voters = data.votes.ayes.length > 0 ? data.votes.ayes.map(y => y[0]) : [];
        const no_voters = data.votes.nays.length > 0 ? data.votes.nays.map(n => n[0]) : [];
        if (yes_voters.includes(this.publicKey)) {
          data.status = 'Approved';
        } else if (no_voters.includes(this.publicKey)) {
          data.status = 'Rejected';
        } else {
          data.status = 'Pending';
        }
        this.proposal = data;
        this.proposal.voters = yes_voters;
      } catch (e) {
        console.error(e);
      } finally {
        $('#proposalModal').modal('toggle');
      }
    },
    setProposalId(proposal_id) {
      this.proposal_id = proposal_id;
    }
  }
}
</script>

<style scoped>
.loader-gif {
  display: none;
  opacity: 0.5;
}

.loader-gif.center {
  margin-left: auto;
  margin-right: auto;
  width: 50%;
}

.label-secondary {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}

.showAttachment {
  cursor: pointer;
}

.bg-grey {
  background-color: rgba(0, 0, 0, 0.03);
}

.card-border {
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
}

.card-header-border {
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}

.custom-margin {
  margin-top: 40px !important;
}

.masked {
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.risk-factor {
  font-size: 12px !important;
}
</style>
